import { Button } from "@carbon/react";
import { Add } from "@carbon/react/icons";

import {
  ActivationRequiredWarning,
  DedicatedTopUpAccounts,
  PageBanner,
} from "../../components";
import { BalanceTable } from "./BalanceTable";

import houseIcon from "../../assets/icons/house.svg";
import { AccountStatement } from "./AccountStatement";
import { Link, Route, Routes } from "react-router-dom";
import { CreateMerchantDedicatedTopUpAccountForm } from "../MerchantDedicatedTopUpAccounts";

export const View = (props) => {
  return (
    <>
      <PageBanner
        iconSource={houseIcon}
        pageTitle={""}
        pageSubtitle={"Add a bank account"}
        pageDescription={"bank accounts are used to pay out your balance."}
        linkTitle={""}
        linkSubtitle={""}
        linkButtonText={"Add a payout bank account"}
        linkButtonUrl={"add-bank-account"}
        linkButtonIcon={<Add />}
        linkButtonIconLeft
        linkButtonClassName={"float-right mr-5"}
        linkButtonAction={props.navigateToAddBankAccount}
      />

      <ActivationRequiredWarning
        title="To payout your balance to your bank, you need to activate your profile"
        subtitle="Our guide will help you complete your Business profile and you’ll start receiving payments. Click this banner to complete your set-up"
        urlTarget="/onboarding"
      />

      <div className="flex-container col flex-break--small mb-5">
        <div className="flex-container justify-content--end align-items--end">
          <div className="flex-container row flex-break--small mb-5">
            {/* <Button
              // onClick={props.navigateToInitiatePayout}
              size="sm"
              className="switchapp-themed create-new-button mt-5 mb-5 mt-md-0 mb-md-0"
              iconDescription="Payout to bank"
              disabled
              title="Feature is currently not available for your account"
            >
              <ArrowUpLeft size={18} />
              Payout To Bank
            </Button> */}

            {/* <Button
              onClick={props.navigateToNewTopUp}
              size="sm"
              kind="tertiary"
              className="switchapp-themed create-new-button"
              iconDescription="Add to balance"
            >
              <Add size={18} />
              Top-Up Your Wallet
            </Button> */}
          </div>

          <DedicatedTopUpAccounts />

          <Link
            to="/balances/top-up-accounts/create"
            className="reserve-new-account--link mb-5 ml-3 align-self--center"
          >
            <Button
              size="sm"
              kind="tertiary"
              className="justify-content--center align-items--center pr-5 b-r-5"
              title="Create New Account"
            >
              <Add size={20} />
              <span className="">New Account</span>
            </Button>
          </Link>
        </div>

        <div className="flex-container row justify-content--end">
          <AccountStatement />
        </div>
      </div>

      <BalanceTable />

      <Routes>
        <Route
          path="top-up-accounts/create"
          element={<CreateMerchantDedicatedTopUpAccountForm />}
        />
      </Routes>
    </>
  );
};
